// node:http/https stand-in backed by fetch(). Enough surface for the
// renderer's simple JSON/text GET helpers (announcements, extension list,
// surveys). Requests to CORS-restricted hosts fail with a network error,
// which callers already handle.
const { EventEmitter } = require("events");

function toUrl(options) {
    if (typeof options === "string") {
        return options;
    }
    if (options instanceof URL) {
        return options.toString();
    }
    const protocol = options.protocol ?? "https:";
    const host = options.hostname ?? options.host ?? "localhost";
    const port = options.port !== undefined ? `:${options.port}` : "";
    return `${protocol}//${host}${port}${options.path ?? "/"}`;
}

function request(options, maybeOptions, maybeCallback) {
    let url = toUrl(options);
    let opts =
        typeof options === "object" && !(options instanceof URL) ? options : {};
    let callback = maybeCallback;
    if (typeof maybeOptions === "function") {
        callback = maybeOptions;
    } else if (typeof maybeOptions === "object" && maybeOptions !== null) {
        opts = maybeOptions;
    }

    const req = new EventEmitter();
    const chunks = [];

    req.write = (chunk) => {
        chunks.push(chunk);
        return true;
    };
    req.setTimeout = () => req;
    req.setHeader = () => req;
    req.getHeader = () => undefined;
    req.abort = () => undefined;
    req.destroy = () => undefined;
    req.end = () => {
        fetch(url, {
            method: opts.method ?? "GET",
            headers: opts.headers ?? {},
            body: chunks.length > 0 ? chunks.join("") : undefined,
        })
            .then(async (fetchRes) => {
                const res = new EventEmitter();
                res.statusCode = fetchRes.status;
                res.statusMessage = fetchRes.statusText;
                res.headers = Object.fromEntries(fetchRes.headers.entries());
                res.setEncoding = () => res;
                res.resume = () => res;
                res.destroy = () => res;
                res.pipe = () => {
                    throw new Error(
                        "response piping is fused off in the web build",
                    );
                };
                if (typeof callback === "function") {
                    callback(res);
                }
                req.emit("response", res);
                const text = await fetchRes.text();
                if (text.length > 0) {
                    res.emit("data", text);
                }
                res.emit("end");
            })
            .catch((err) => req.emit("error", err));
        return req;
    };

    return req;
}

function get(options, maybeOptions, maybeCallback) {
    const req = request(options, maybeOptions, maybeCallback);
    req.end();
    return req;
}

module.exports = {
    request,
    get,
    Agent: class Agent {},
    globalAgent: {},
    STATUS_CODES: {},
};
